import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Start with 23:59:15 as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-3xl md:text-5xl font-black text-red-500 tracking-tighter" data-id="element-47">
      <div className="bg-slate-900 px-3 py-2 rounded-lg border border-red-500/30 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-48">
        {format(timeLeft.hours)}
      </div>
      <span className="text-red-500/50 pb-1" data-id="element-49">:</span>
      <div className="bg-slate-900 px-3 py-2 rounded-lg border border-red-500/30 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-50">
        {format(timeLeft.minutes)}
      </div>
      <span className="text-red-500/50 pb-1" data-id="element-51">:</span>
      <div className="bg-slate-900 px-3 py-2 rounded-lg border border-red-500/30 shadow-[0_0_15px_rgba(239,68,68,0.2)]" data-id="element-52">
        {format(timeLeft.seconds)}
      </div>
    </div>;
}